import { Component, Input, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FilenamePipe } from '../../../pipes/filename.pipe';

@Component({
	selector: 'app-segmented-images',
	templateUrl: './segmented-images.component.html',
	styleUrls: ['./segmented-images.component.scss'],
	providers: [FilenamePipe]
})
export class SegmentedImagesComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('segmentedImagesForm', { static: true }) segmentedImagesForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	segmentedImagesFormSubscription: Subscription;
	externalCSV = 0;

	constructor(
		private comService: ComponentService,
		private overlay: OverlayService,
		private http: HttpClient,
		private filenamePipe: FilenamePipe,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.componentData.config.responsive = this.componentData.config.responsive == 1 ? 1 : 0;

		if (this.componentData.config.use_external_csv) {
			this.externalCSV = 1;
		}

		this.segmentedImagesFormSubscription = this.segmentedImagesForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.segmentedImagesForm.dirty && this.segmentedImagesForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.segmentedImagesForm.dirty && this.segmentedImagesForm.valid),
				debounceTime(2000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.segmentedImagesFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	addImage() {
		if (this.componentData.config.items.length < 101) {
			this.componentData.config.items.push({ image: '', link: '', tag: '' });
		} else {
			this.overlay.updateOverlay(true, 'You have reached the maximum Images limit of 100 images', 'alert');
		}
	}

	removeImage(index) {
		this.componentData.config.items.splice(index, 1);
	}

	externalSwitchData(value) {
		this.externalCSV = value ? 1 : 0;
		this.componentData.config.use_external_csv = value ? true : false;
	}

	csvCheck(url) {
		let headerError = false;
		let csvData = [];
		this.http.get(url, { responseType: 'text' }).subscribe((data) => {
			let csvRows = data.split('\r\n');
			csvRows.forEach((item) => {
				if (item.length) {
					csvData.push(item.split(','));
				}
			});

			const fileName = this.filenamePipe.transform(url);

			if (!csvData.length) {
				this.overlay.updateOverlay(true, `Minimum number of rows to add is 3. ${fileName} contains no rows to add.`, 'alert');
				this.componentData.config.csv_list = '';
			} else if (csvData.length < 4) {
				this.overlay.updateOverlay(
					true,
					`Minimum number of rows to add is 3. ${fileName} contains ${csvData.length - 1} rows to add.`,
					'alert'
				);
				this.componentData.config.csv_list = '';
			} else if (csvData.length > 1001) {
				this.overlay.updateOverlay(
					true,
					`Maximum number of rows to add is 1000. ${fileName} contains ${csvData.length - 1} rows to add.`,
					'alert'
				);
				this.componentData.config.csv_list = '';
			} else {
				for (const title of csvData[0]) {
					const headerTitles = ['tag', 'image', 'cta'];
					if (!headerTitles.includes(title.toLowerCase().trim())) {
						headerError = true;
					}
				}

				if (headerError) {
					this.overlay.updateOverlay(
						true,
						`There is an error with the CSV headers in ${fileName}. Please ensure they use the "Tag", "Image", "CTA" titles.`,
						'alert'
					);
					this.componentData.config.csv_list = '';
				} else {
					this.overlay.updateOverlay(true, `${fileName} contains ${csvData.length - 1} rows to add.`, 'alert');
					this.componentData.config.csv_list = url;
				}
			}
			this.cd.detectChanges();
		});
	}
}
